var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Dificuldade:' +_vm.getDificuldade),expression:"'Dificuldade:' +getDificuldade"}]},[_c('i',{staticClass:"vtl vtl-dificuldade"},[_c('span',{staticClass:"label-dificuldade"},[_vm._v(_vm._s(_vm.getDificuldade))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }